export const GET_ALL_CUSTOMERS = 'GET_ALL_CUSTOMERS'
export const GET_ALL_CUSTOMERS_OFFLINE = 'GET_ALL_CUSTOMERS_OFFLINE'
export const GET_TOTAL_CUSTOMERS = 'GET_TOTAL_CUSTOMERS'
export const GET_VENDOR_PURCHASES = 'GET_VENDOR_PURCHASES'
export const GET_VENDOR_CAMPAIGNS = 'GET_VENDOR_CAMPAIGNS'

export const GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN = 'GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN'
